export class ResponseProyectoEducativoDataModel{
    payload:ProyectoEducativoDataModel;

    constructor(){
        this.payload = new ProyectoEducativoDataModel();
    }
}


export class ProyectoEducativoDataModel{
    idJardin: number;
    introduccion:string;
    capacidadSalacunaMenor:number;
    capacidadSalacunaMayor:number;
    capacidadSalacunaMixta:number;
    capacidadSalacunaNoConvencional:number;
    capacidadMedioMenor:number;
    capacidadMedioMayor:number;
    capacidadTransicion1:number;
    capacidadTransicion2:number;
    heterogeneo:number;
    cantidadDirectora:number;
    cantidadEducadora:number;
    cantidadTecnico:number;
    cantidadAgente:number;
    cantidadAgenteEducativa:number;
    cantidadAdministrativa:number;
    cantidadAuxiliar:number;
    cantidadManipuladora:number;
    resenaHistorica:string;
    entorno:string;
    sello:string;
    vision:string;
    mision:string;
    valores:string;
    definiciones:string;
    perfiles:string;
    objetivosGenerales:string;
    objetivosEstrategicos:string;
    seguimiento:string;
    proyecciones:string;
    fechaCreacion:string;
    fechaActualizacion:string;
    capacidadMedioMixto:number;
    capacidadMedioTC:number;
    
    constructor(){
        this.idJardin = 0;
        this.introduccion = '';
        this.capacidadSalacunaMenor = 0;
        this.capacidadSalacunaMayor = 0;
        this.capacidadSalacunaMixta = 0;
        this.capacidadSalacunaNoConvencional = 0;
        this.capacidadMedioMenor = 0;
        this.capacidadMedioMayor = 0;
        this.capacidadTransicion1 = 0;
        this.capacidadTransicion2 = 0;
        this.heterogeneo = 0;
        this.cantidadDirectora = 0;
        this.cantidadEducadora = 0;
        this.cantidadTecnico = 0;
        this.cantidadAgente= 0;
        this.cantidadAdministrativa = 0;  
        this.cantidadAuxiliar = 0;
        this.cantidadManipuladora = 0;
        this.resenaHistorica = '';
        this.entorno = '';
        this.sello = '';
        this.vision = '';
        this.mision = '';
        this.valores = '';
        this.definiciones = '';
        this.perfiles = '';
        this.objetivosGenerales = '';
        this.objetivosEstrategicos = '';
        this.seguimiento = '';
        this.proyecciones = '';
        this.fechaCreacion= '';
        this.fechaActualizacion= '';
        this.capacidadMedioMixto= 0; 
        this.capacidadMedioTC= 0; 
    }
}



export class ResponseProyectoEducativoContextoDataModel{
    payload:ProyectoEducativoContextoDataModel;

    constructor(){
        this.payload = new ProyectoEducativoContextoDataModel();
    }
}

export class ProyectoEducativoContextoDataModel{
    idJardin: number;
    introduccion:string;
    capacidadSalacunaMenor:number;
    capacidadSalacunaMayor:number;
    capacidadSalacunaMixta:number;//sala cuna hetereogenea
    capacidadSalacunaNoConvencional:number;
    capacidadMedioMenor:number;
    capacidadMedioMayor:number;
    capacidadTransicion1:number;
    capacidadTransicion2:number;
    heterogeneo:number;//Medio y Transición No Convencional
    cantidadDirectora:number;
    cantidadEducadora:number;
    cantidadTecnico:number;
    cantidadAgente:number;
    cantidadAgenteEducativa:number;
    cantidadAdministrativa:number;
    cantidadAuxiliar:number;
    cantidadManipuladora:number;
    resenaHistorica:string;
    entorno:string;
    capacidadMedioMixto:number;
    capacidadMedioTC:number;
   
    constructor(){
        this.idJardin = 0;
        this.introduccion = '';
        this.capacidadSalacunaMenor = 0;
        this.capacidadSalacunaMayor = 0;
        this.capacidadSalacunaMixta = 0;
        this.capacidadMedioMenor = 0;
        this.capacidadMedioMayor = 0;
        this.capacidadTransicion1 = 0;
        this.capacidadTransicion2 = 0;
        this.heterogeneo = 0;
        this.cantidadDirectora = 0;
        this.cantidadEducadora = 0;
        this.cantidadTecnico = 0;
        this.cantidadAgente= 0;
        this.cantidadAdministrativa = 0;  
        this.cantidadAuxiliar = 0;
        this.cantidadManipuladora = 0;
        this.resenaHistorica = '';
        this.entorno = '';
        this.capacidadSalacunaNoConvencional= 0; 
        this.capacidadMedioMixto= 0; 
        this.capacidadMedioTC= 0; 
       
    }
}


export class ResponseProyectoEducativoIdearioDataModel{
    payload:ProyectoEducativoIdearioDataModel;

    constructor(){
        this.payload = new ProyectoEducativoIdearioDataModel();
    }
}

export class ProyectoEducativoIdearioDataModel{
    idJardin: number;
    sello:string;
    vision:string;
    mision:string;
    valores:string;
    definiciones:string;
    perfiles:string;

    
    constructor(){
        this.idJardin = 0;
        this.sello = '';
        this.vision = '';
        this.mision = '';
        this.valores = '';
        this.definiciones = '';
        this.perfiles = '';
      
    }
}


export class ResponseProyectoEducativoObjetivosDataModel{
    payload:ProyectoEducativoObjetivosDataModel;

    constructor(){
        this.payload = new ProyectoEducativoObjetivosDataModel();
    }
}


export class ProyectoEducativoObjetivosDataModel{
    idJardin: number;
    objetivosGenerales:string;
    objetivosEstrategicos:string;
  
    
    constructor(){
        this.idJardin = 0;
        this.objetivosGenerales = '';
        this.objetivosEstrategicos = '';
       
    }
}


export class ResponseProyectoEducativoEvaluacionDataModel{
    payload:ProyectoEducativoEvaluacionDataModel;

    constructor(){
        this.payload = new ProyectoEducativoEvaluacionDataModel();
    }
}

export class ProyectoEducativoEvaluacionDataModel{
    idJardin: number;
    seguimiento:string;
    proyecciones:string;
    
    constructor(){
        this.idJardin = 0;
        this.seguimiento = '';
        this.proyecciones = '';
    }
}

export class ResponseProyectoEducativoFechasActualizacionModel{
    payload:ProyectoEducativoFechasActualizacionModel;

    constructor(){
        this.payload = new ProyectoEducativoFechasActualizacionModel();
    }
}
export class ProyectoEducativoFechasActualizacionModel{
    fechaInicio:string;
    idJardin: number;
    idPeriodo: number;
    fecha1:string;
    fecha2:string;
    fecha3:string;
    fechaTermino:string;
    
    constructor(){
        this.fechaInicio = '';
        this.idJardin = 0;
        this.idPeriodo = 0;
        this.fecha1 = ''
        this.fecha2 = '';
        this.fecha3 = '';
        this.fechaTermino = '';
    }
}